import React, { useState, useEffect } from 'react';
import {Star, Heart, Award, Shield, Zap, Droplets } from 'lucide-react';
import wildArmyLogo from './PHOTO-2025-08-04-14-09-20.jpg';
import deterImage from './deter.jpg';

export default function WildArmyPage() {
  const [selectedProduct, setSelectedProduct] = useState(null);
  // const [likedProducts, setLikedProducts] = useState(new Set());

  // const products = [
  //   {
  //     id: 'wild-army-classic',
  //     name: 'Wild Army Classic',
  //     category: 'SIGNATURE FRAGRANCES',
  //     description: 'A sophisticated blend of woody and spicy notes for the modern gentleman',
  //     features: [
  //       { title: 'Long-lasting', description: 'Premium concentration for extended wear', color: 'orange', icon: Shield },
  //       { title: 'Masculine', description: 'Bold and sophisticated scent profile', color: 'blue', icon: Heart },
  //       { title: 'Premium', description: 'High-quality ingredients and craftsmanship', color: 'green', icon: Award },
  //       { title: 'Versatile', description: 'Perfect for any occasion', color: 'purple', icon: Star }
  //     ],
  //     sizes: [
  //       { size: '50ml', type: 'Regular Size', color: 'orange', price: '₹850' },
  //       { size: '100ml', type: 'Large Size', color: 'blue', price: '₹1200', popular: true }
  //     ],
  //     ingredients: [
  //       'Alcohol',
  //       'Fragrance',
  //       'Essential Oils',
  //       'Fixatives',
  //       'Natural Extracts',
  //       'Premium Compounds'
  //     ],
  //     gradient: 'from-orange-50 via-white to-blue-50/30',
  //     badgeColor: 'orange',
  //     primaryColor: 'orange',
  //     secondaryColor: 'blue',
  //     rating: 4.8,
  //     reviews: 1247
  //   },
  //   {
  //     id: 'wild-army-intense',
  //     name: 'Wild Army Intense',
  //     category: 'PREMIUM FRAGRANCES',
  //     description: 'Bold and powerful fragrance for the confident man',
  //     features: [
  //       { title: 'High Concentration', description: 'Maximum strength and longevity', color: 'blue', icon: Zap },
  //       { title: 'Bold', description: 'Strong and commanding presence', color: 'orange', icon: Shield },
  //       { title: 'Confident', description: 'For the man who knows what he wants', color: 'green', icon: Award },
  //       { title: 'Sophisticated', description: 'Elegant and refined composition', color: 'purple', icon: Star }
  //     ],
  //     sizes: [
  //       { size: '30ml', type: 'Travel Size', color: 'blue', price: '₹650' },
  //       { size: '75ml', type: 'Premium Size', color: 'orange', price: '₹1100', popular: true }
  //     ],
  //     gradient: 'from-blue-50 via-white to-orange-50/30',
  //     badgeColor: 'blue',
  //     primaryColor: 'blue',
  //     secondaryColor: 'orange',
  //     rating: 4.7,
  //     reviews: 892
  //   },
  //   {
  //     id: 'wild-army-fresh',
  //     name: 'Wild Army Fresh',
  //     category: 'DAILY FRAGRANCES',
  //     description: 'Light and refreshing scent for daily wear',
  //     features: [
  //       { title: 'Fresh', description: 'Crisp and invigorating notes', color: 'green', icon: Droplets },
  //       { title: 'Light', description: 'Subtle and comfortable wear', color: 'blue', icon: Heart },
  //       { title: 'Versatile', description: 'Perfect for everyday use', color: 'orange', icon: Award },
  //       { title: 'Modern', description: 'Contemporary scent profile', color: 'purple', icon: Star }
  //     ],
  //     sizes: [
  //       { size: '100ml', type: 'Large Size', color: 'green', price: '₹750' },
  //       { size: '200ml', type: 'Family Size', color: 'blue', price: '₹1200', popular: true }
  //     ],
  //     gradient: 'from-green-50 via-white to-blue-50/30',
  //     badgeColor: 'green',
  //     primaryColor: 'green',
  //     secondaryColor: 'blue',
  //     rating: 4.6,
  //     reviews: 634
  //   }
  // ];

  // const getColorClasses = (color) => {
  //   const colors = {
  //     orange: { bg: 'bg-orange-100', border: 'border-orange-200', text: 'text-orange-900', badge: 'bg-orange-100', badgeText: 'text-orange-800' },
  //     blue: { bg: 'bg-blue-100', border: 'border-blue-200', text: 'text-blue-900', badge: 'bg-blue-100', badgeText: 'text-blue-800' },
  //     green: { bg: 'bg-green-100', border: 'border-green-200', text: 'text-green-900', badge: 'bg-green-100', badgeText: 'text-green-800' },
  //     purple: { bg: 'bg-purple-100', border: 'border-purple-200', text: 'text-purple-900', badge: 'bg-purple-100', badgeText: 'text-purple-800' },
  //     pink: { bg: 'bg-pink-100', border: 'border-pink-200', text: 'text-pink-900', badge: 'bg-pink-100', badgeText: 'text-pink-800' }
  //   };
  //   return colors[color] || colors.blue;
  // };

  // const toggleLike = (productId) => {
  //   const newLikedProducts = new Set(likedProducts);
  //   if (newLikedProducts.has(productId)) {
  //     newLikedProducts.delete(productId);
  //   } else {
  //     newLikedProducts.add(productId);
  //   }
  //   setLikedProducts(newLikedProducts);
  // };

  // const renderStars = (rating) => {
  //   return Array.from({ length: 5 }, (_, i) => (
  //     <Star
  //       key={i}
  //       className={`w-3 h-3 ${i < Math.floor(rating) ? 'text-yellow-400 fill-current' : 'text-gray-300'}`}
  //     />
  //   ));
  // };

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white py-12">
      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-br from-orange-50 via-white to-blue-50/30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            
            {/* Left column - Description */}
            <div className="w-full lg:w-1/2 text-center lg:text-left space-y-6">
              
              {/* Main heading */}
              <div className="space-y-4">
                <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">
                  <span className="text-orange-600">WILD ARMY</span>
                </h1>
                
                <div className="w-16 h-0.5 bg-gradient-to-r from-orange-600 to-blue-500 rounded-full mx-auto lg:mx-0"></div>
                
                <p className="text-lg font-light text-gray-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                  Signature <span className="font-semibold text-orange-900">men's perfume line</span> for the modern gentleman
                </p>
              </div>

              {/* Description */}
              <div className="space-y-4 max-w-xl mx-auto lg:mx-0">
                <p className="text-base text-gray-600 leading-relaxed">
                  Experience the epitome of masculine elegance with Wild Army. Our signature men's perfume collection embodies strength, sophistication, and timeless appeal, making it the choice of discerning gentlemen.
                </p>
                
                {/* Key benefits */}
                <div className="grid grid-cols-2 gap-4 pt-4">
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center">
                      <Star className="w-3 h-3 text-orange-600" />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Premium Fragrance</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                      <Shield className="w-3 h-3 text-blue-600" />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Masculine Elegance</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                      <Award className="w-3 h-3 text-green-600" />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Long-lasting</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center">
                      <Heart className="w-3 h-3 text-purple-600" />
                    </div>
                    <span className="text-sm font-medium text-gray-700">Sophisticated</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Right column - Wild Army Image */}
            <div className="w-full lg:w-1/2 relative flex items-center justify-center">
              <div className="relative w-full max-w-sm h-64 flex items-center justify-center">
                {/* Main Wild Army logo display */}
                <div className="relative z-10 w-full max-w-xs">
                  <div className="w-full aspect-square bg-white rounded-2xl flex items-center justify-center p-8">
                    <img 
                      src={wildArmyLogo} 
                      alt="Wild Army Logo" 
                      className="h-full w-full object-contain max-h-32 rounded-xl"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                      }}
                    />
                    <div className="hidden items-center justify-center h-full w-full">
                      <span className="text-xl font-bold text-gray-700 text-center">Wild Army Logo</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="py-12 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">Products</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Discover the advanced technology and premium ingredients that make Wild Army the perfect choice for masculine fragrances
            </p>
          </div>

          <div className="space-y-12">
            {/* Wild Army Classic Section */}
            <div className="flex flex-col lg:flex-row items-center gap-8">
              
              {/* Product Description - LEFT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="space-y-6">
                  {/* Product Title */}
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4 tracking-wider">Wild Army Classic</h3>
                    
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Product Description</h4>
                    <p className="text-base text-gray-600 leading-relaxed mb-4">
                      Our signature Wild Army Classic is a sophisticated blend of woody and spicy notes designed for the modern gentleman. This premium fragrance combines traditional masculine elements with contemporary sophistication, creating a timeless scent that embodies strength and elegance.
                    </p>
                  </div>

                  {/* Sizes */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Available Sizes</h4>
                    <div className="flex items-center space-x-4">
                      <div className="text-center">
                        <span className="text-2xl font-bold text-orange-600 block">100ml</span>
                        <span className="text-sm text-gray-500">Large Size</span>
                      </div>
                      <span className="text-gray-400 text-base">AND</span>
                      <div className="text-center">
                        <span className="text-2xl font-bold text-blue-600 block">50ml</span>
                        <span className="text-sm text-gray-500">Regular Size</span>
                      </div>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Features</h4>
                    <div className="space-y-2">
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-orange-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Long-lasting premium concentration</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-blue-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Masculine and sophisticated</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-green-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Premium quality ingredients</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Versatile for any occasion</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-orange-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Woody and spicy notes</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-100">
                        <span className="w-3 h-3 bg-green-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Elegant packaging</span>
                      </div>
                    </div>
                  </div>

                  {/* Ingredients */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Ingredients</h4>
                    <p className="text-base text-gray-600 leading-relaxed">
                      Alcohol, Fragrance, Essential Oils, Fixatives, Natural Extracts, Premium Compounds.
                    </p>
                  </div>
                </div>
              </div>

              {/* Product Image - RIGHT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center justify-center ">
                  <div className="w-96 h-96 bg-gradient-to-br from-orange-50 via-white to-blue-50/30 rounded-2xl flex items-center justify-center p-12 relative overflow-hidden">
                    {/* Logo */}
                    <div className="relative z-10 flex items-center justify-center">
                      <div className="w-160 h-160 bg-white rounded-xl flex items-center justify-center p-8">
                        <img 
                          src={deterImage} 
                          alt="Wild Army Classic" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Wild Army Intense Section */}
            <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
              
              {/* Product Description - LEFT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="space-y-6">
                  {/* Product Title */}
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4 tracking-wider">Wild Army Intense</h3>
                    
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Product Description</h4>
                    <p className="text-base text-gray-600 leading-relaxed mb-4">
                      Wild Army Intense is a bold and powerful fragrance designed for the confident man who knows what he wants. With maximum concentration and strong, commanding presence, this premium scent makes a lasting impression.
                    </p>
                  </div>

                  {/* Size */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Available Sizes</h4>
                    <div className="flex items-center space-x-4">
                      <div className="text-center">
                        <span className="text-2xl font-bold text-blue-600 block">75ml</span>
                        <span className="text-sm text-gray-500">Premium Size</span>
                      </div>
                      <span className="text-gray-400 text-base">AND</span>
                      <div className="text-center">
                        <span className="text-2xl font-bold text-orange-600 block">30ml</span>
                        <span className="text-sm text-gray-500">Travel Size</span>
                      </div>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Features</h4>
                    <div className="space-y-2">
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-blue-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">High concentration formula</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-orange-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Bold and commanding</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-green-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Confident and sophisticated</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Elegant composition</span>
                      </div>
                    </div>
                  </div>

                  {/* Ingredients */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Ingredients</h4>
                    <p className="text-base text-gray-600 leading-relaxed">
                      High-concentration alcohol, Premium fragrance compounds, Essential oils, Long-lasting fixatives.
                    </p>
                  </div>
                </div>
              </div>

              {/* Product Image - RIGHT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center justify-center">
                  <div className="w-96 h-96 bg-gradient-to-br from-blue-50 via-white to-orange-50/30 rounded-2xl flex items-center justify-center p-12 relative overflow-hidden">
                    {/* Logo */}
                    <div className="relative z-10 flex items-center justify-center">
                      <div className="w-80 h-80 bg-white rounded-xl flex items-center justify-center p-8">
                        <img 
                          src={wildArmyLogo} 
                          alt="Wild Army Intense" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Wild Army Fresh Section */}
            <div className="flex flex-col lg:flex-row items-center gap-8">
              
              {/* Product Description - LEFT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="space-y-6">
                  {/* Product Title */}
                  <div>
                    <h3 className="text-3xl font-bold text-gray-900 mb-4 tracking-wider">Wild Army Fresh</h3>
                    
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Product Description</h4>
                    <p className="text-base text-gray-600 leading-relaxed mb-4">
                      Wild Army Fresh offers a light and refreshing scent perfect for daily wear. This versatile fragrance combines crisp, invigorating notes with modern sophistication, making it ideal for the contemporary man who values both comfort and style.
                    </p>
                  </div>

                  {/* Size */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Available Sizes</h4>
                    <div className="flex items-center space-x-4">
                      <div className="text-center">
                        <span className="text-2xl font-bold text-green-600 block">200ml</span>
                        <span className="text-sm text-gray-500">Family Size</span>
                      </div>
                      <span className="text-gray-400 text-base">AND</span>
                      <div className="text-center">
                        <span className="text-2xl font-bold text-blue-600 block">100ml</span>
                        <span className="text-sm text-gray-500">Large Size</span>
                      </div>
                    </div>
                  </div>

                  {/* Features */}
                  <div className="mb-4">
                    <h4 className="text-lg font-semibold text-gray-800 mb-3">Key Features</h4>
                    <div className="space-y-2">
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-green-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Fresh and invigorating</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-blue-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Light and comfortable</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-orange-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Versatile for everyday use</span>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-white rounded-lg border border-gray-200">
                        <span className="w-3 h-3 bg-purple-600 rounded-full"></span>
                        <span className="text-base text-gray-700 tracking-wide">Modern scent profile</span>
                      </div>
                    </div>
                  </div>

                  {/* Ingredients */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-2">Ingredients</h4>
                    <p className="text-base text-gray-600 leading-relaxed">
                      Light alcohol base, Fresh fragrance compounds, Natural extracts, Gentle fixatives.
                    </p>
                  </div>
                </div>
              </div>

              {/* Product Image - RIGHT SIDE */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center justify-center">
                  <div className="w-96 h-96 bg-gradient-to-br from-green-50 via-white to-blue-50/30 rounded-2xl flex items-center justify-center p-12 relative overflow-hidden">
                    {/* Logo */}
                    <div className="relative z-10 flex items-center justify-center">
                      <div className="w-80 h-80 bg-white rounded-xl flex items-center justify-center p-8">
                        <img 
                          src={wildArmyLogo} 
                          alt="Wild Army Fresh" 
                          className="w-full h-full object-contain"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-start mb-4">
                <h3 className="text-lg font-bold text-gray-900">{selectedProduct.name}</h3>
                <button 
                  onClick={() => setSelectedProduct(null)}
                  className="text-gray-400 hover:text-gray-600 transition-colors duration-200"
                >
                  <span className="text-xl">×</span>
                </button>
              </div>
              
              <div className="space-y-4">
                <p className="text-sm text-gray-600">{selectedProduct.longDescription}</p>
                
                {selectedProduct.ingredients && (
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2 text-sm">Ingredients:</h4>
                    <div className="grid grid-cols-2 gap-2">
                      {selectedProduct.ingredients.map((ingredient, idx) => (
                        <div key={idx} className="text-xs text-gray-600 bg-gray-50 px-2 py-1 rounded">
                          {ingredient}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                
                {selectedProduct.washes && (
                  <div className="flex items-center space-x-4">
                    <div className="flex items-center space-x-2">
                      <Droplets className="w-4 h-4 text-blue-600" />
                      <span className="text-xs font-medium">{selectedProduct.washes} washes</span>
                    </div>
                    {selectedProduct.loadType && (
                      <div className="flex items-center space-x-2">
                        <Zap className="w-4 h-4 text-orange-600" />
                        <span className="text-xs font-medium">{selectedProduct.loadType}</span>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
} 